import Header from 'components/ui/Header'

export default function MainLayout({children}) {

    return (
        <>

            <div className="flex flex-col w-screen max-h-screen overflow-hidden bg-bglight dark:bg-bgdark">
                <div className="h-16 lg:mb-8">
                    <Header/>
                </div>
                <main className="flex flex-row">
                    <div className="flex flex-row justify-center w-screen lg:container lg:mx-auto">
                        {children}
                    </div>
                </main>
            </div>
        </>
    )
}
